module.exports = __webpack_public_path__ + "static/img/login3.30159a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/login3.png
// module id = 1243
// module chunks = 0